<template>
  <v-app
    :class="[
      hubbdata.openDyslexic ? 'open-dyslexic' : '',
      $route.path === '/welcome' || $route.path == '/terms' ? 'border' : '',
      isAndroid ? 'android-top-safe-area android-bottom-safe-area' : '',
    ]"
  >
    <BypassBlock v-if="$route.path != '/welcome'"></BypassBlock>

    <Header
      v-if="
        $route.path != '/welcome' &&
        $route.name != 'user_register' &&
        $route.path != '/terms'
      "
    >
    </Header>

    <v-main id="main-content" tabindex="-1">
      <transition name="fade" mode="out-in">
        <router-view :key="$route.fullPath" />
      </transition>
    </v-main>
  </v-app>
</template>

<script>
import BypassBlock from "./components/App/BypassBlock.vue";
import Header from '@/components/Header/Header';
import hubbdata from "@/hubbdata";

export default {
  name: 'App',
  components: {
    BypassBlock,
    Header,
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        if (to & to.name) {
          document.title = to.name.replace(/_|-|\./g, ' ') || 'App';
        } else {
          document.title = "Redcar and Cleveland's Care Leavers App"
        }
      }
    },
  },
  data: () => ({
    routeName: null,
    alert: false,
    openDyslexic: false,
    isAndroid: false,
  }),
  methods: {
    currentRoute() {
      this.$nextTick(() => {
        this.routeName = this.$route.name
      });
    }
  },
  mounted() {
    if (localStorage.getItem('terms_accepted') === null) {
      this.$router.push("/welcome")
    }

    if (localStorage.getItem('current_lang') !== null) {
      hubbdata.state.current_lang = localStorage.getItem('current_lang')
    } else {
      hubbdata.state.current_lang = "en"
    }

    hubbdata.dispatch("initDB");
    hubbdata.dispatch("setFont");

    try {
      this.isAndroid =
        window.cordova && window.cordova.platformId === "android";
    } catch (e) {
      this.isAndroid = false;
    }
  },
  computed: {
    translations() {
      return hubbdata.getters.translations;
    },
    hubbdata() {
      return hubbdata.state;
    },
  },
};
</script>

<style lang="scss">
.border .v-main {
  margin-bottom: 0px !important;
  border: solid 6px $primary;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.2s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}

a {
  color: #0062ae !important;
}

*:focus {
  outline: $red solid 3px;
}

.v-list-item__content .v-list-item__content:focus-within,  .v-list--two-line .v-list-item__content:focus-within, .icons:focus .v-card {
  outline: #0062AE solid 3px;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
  color: black !important;
  background-color: white;
}

.v-main {
  margin-bottom: 40px;
}

.v-step {
  max-width: 280px!important;
}

.v-step__header {
  border-bottom: 3px solid $secondary;
  font-size: 18px;
}

.v-step__button {
  border: 0.05rem solid $secondary!important;
}

@media screen and (min-width: 960px) {
  .desktop-container {
    max-width: 750px;
    margin: auto;
  }
}

@media screen and (min-width: 960px) {
  .v-list-item__subtitle {
    font-size: 16px;
  }
}
</style>
